// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CountryConfig from "../country/CountryConfig.bs.js";

var defaultValue = {
  countryConfig: CountryConfig.getConfig(/* INDIA */2)
};

var context = React.createContext(defaultValue);

function useAppContext(param) {
  return React.useContext(context);
}

export {
  defaultValue ,
  context ,
  useAppContext ,
  
}
/* defaultValue Not a pure module */
